import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

export let loadedAnalytics: AnalyticsBrowser | null;

export const setAnalyticsBrowser = (analyticsBrowser: AnalyticsBrowser) => {
  loadedAnalytics = analyticsBrowser;
};
